import axios from "axios";
import { setContent } from "../slices/contentSlice";

export const getStrapiContent = () => {
  return async (dispatch) => {
  try {
    const response = await axios.get(process.env.REACT_APP_CONTENT_URL);
    const data = response?.data?.data?.[0]?.attributes;

    const contentData = {
      authContent: data?.web_auth?.data?.attributes,
      dashboardContent: data?.web_dashboard?.data?.attributes,
      fundsContent: data?.web_fund?.data?.attributes,
      corpKycContent: data?.corporate_kyc_form?.data?.attributes,
      corpAOContent: data?.corporate_account_opening?.data?.attributes,      
    };
    dispatch(setContent(contentData));
  } catch (error) {
  }}
}
